import { render } from "./scriptLoader.vue?vue&type=template&id=745f9ac6&ts=true"
import script from "./scriptLoader.vue?vue&type=script&lang=ts"
export * from "./scriptLoader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__